import type { EventType } from '@cocoonspace/api'
import { useState } from 'react'
import { DialogTitle } from '@cocoonspace/ui/components/dialog'
import {
	Sheet,
	SheetContent,
	SheetTrigger,
} from '@cocoonspace/ui/components/sheet'
import { useLingui } from '@lingui/react/macro'
import { PencilIcon } from 'lucide-react'

import { ScheduleCardActionBtn } from '../../scheduling-card'
import { EditEventType } from '../edition/edit-event-type'

export const EditAction = ({ eventType }: { eventType: EventType }) => {
	const { t } = useLingui()
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Sheet
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			<SheetTrigger asChild>
				<ScheduleCardActionBtn title={t`Modifier`}>
					<PencilIcon />
				</ScheduleCardActionBtn>
			</SheetTrigger>

			<SheetContent className='flex max-w-full flex-col gap-0 p-0 max-md:!w-full md:max-w-sm'>
				<DialogTitle className='sr-only'>{t`Modifier le type de rendez-vous`}</DialogTitle>

				<EditEventType
					id={eventType.id}
					onSuccess={() => setIsOpen(false)}
				/>
			</SheetContent>
		</Sheet>
	)
}
